import { render } from "./ParentPlatform.vue?vue&type=template&id=690bdc8d"
import script from "./ParentPlatform.vue?vue&type=script&lang=js"
export * from "./ParentPlatform.vue?vue&type=script&lang=js"

import "./ParentPlatform.vue?vue&type=style&index=0&id=690bdc8d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__